import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import img1 from '../toolteeth.jpg';

function FirstSection() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid item>
      <Grid container justifyContent="center" sx={{ padding: '20px' }}>
        <Grid item xs={12} md={6} sx={{ padding: isSmallScreen ? '10px' : '18px' }}>
          <img
            src={img1}
            alt="First Half Image"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{ padding: '20px' }}>
          <Typography sx={{ marginBottom: '10px', fontSize: '35px', fontWeight: 500 }}>
            A Warm Legacy Built On High-end Dentistry
          </Typography>
          <Typography sx={{ fontSize: '25px', marginBottom: '15px', lineHeight: '2.0' }}>
            Visit us for exceptional dentistry; from tooth fillings to full-mouth implants, all done
            by specialists and highly experienced general dentists.
          </Typography>
          <Typography sx={{ fontSize: '18px', marginBottom: '10px', lineHeight: '2.0' }}>
            Visit us for exceptional dentistry; from tooth fillings to full-mouth implants, all done
            by specialists and highly experienced general dentists.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default FirstSection;
